import { render } from "./Ordenes.vue?vue&type=template&id=2c224fbe"
import script from "./Ordenes.vue?vue&type=script&lang=js"
export * from "./Ordenes.vue?vue&type=script&lang=js"

import "./Ordenes.vue?vue&type=style&index=0&id=2c224fbe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__